import { render, staticRenderFns } from "./PlatformBlacklist.vue?vue&type=template&id=00a7d279&scoped=true&"
import script from "./PlatformBlacklist.vue?vue&type=script&lang=js&"
export * from "./PlatformBlacklist.vue?vue&type=script&lang=js&"
import style0 from "./PlatformBlacklist.vue?vue&type=style&index=0&id=00a7d279&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a7d279",
  null
  
)

export default component.exports